import { serverInstance } from "./rollbar";

export class Logger {
  static safeToString(arg: unknown): string {
    if (arg === null) return "null";
    if (arg === undefined) return "undefined";

    if (arg instanceof Error) {
      return `${arg.name}: ${arg.message}\n${arg.stack}`;
    }

    if (typeof arg === "object") {
      try {
        return JSON.stringify(arg, null, 2);
      } catch {
        // Handle circular references
        return `[Circular or non-serializable object: ${Object.prototype.toString.call(arg)}]`;
      }
    }

    return String(arg);
  }

  static error(...args: unknown[]) {
    const formatted = args.map((a) => this.safeToString(a));
    serverInstance.error(...formatted);
    console.error(...formatted);
  }
}
